<template>
  <div class="info">
<!--    <HomePic/>-->
<!--    <BreadNav/>-->
    <div class="mod-title">
      <span class="main">联系我们</span><span class="en">project</span>
    </div>
    <div class="sub-main">
      <!--      <div class="left">-->
      <!--        <LeftMenu/>-->
      <!--      </div>-->
      <div class="right">
        <div v-html="contact.content"></div>
        <div class="map">
          <img class="addr-img" alt="none" src="@/assets/common/img/map.png"></img>
          <div class="addr-text" v-html="contact.content"></div>
<!--          <baidu-map-->
<!--            id="allmap"-->
<!--            @ready="mapReady"-->
<!--            :scroll-wheel-zoom="true"-->
<!--          >-->
<!--            &lt;!&ndash; bm-marker 就是标注点 定位在point的经纬度上 跳动的动画 &ndash;&gt;-->
<!--            <bm-marker :position="point" animation="BMAP_ANIMATION_BOUNCE">-->
<!--              <bm-info-window :show="true">-->
<!--                <div style="font-size: 18px">{{info.fullName}}</div>-->
<!--                <div style="font-size: 11px">{{info.addr}}</div>-->
<!--              </bm-info-window>-->
<!--            </bm-marker>-->
<!--          </baidu-map>-->
        </div>
      </div>

    </div>
  </div>
</template>

<style lang="less">
#allmap {
  height: 600px;
  width: 100%;
  margin: 0 auto;
}
</style>

<script>
import HomePic from '@/components/style2/HomePic.vue';
import BreadNav from '@/components/style2/BreadNav.vue';
import { get } from '@/util/Http';
import { INFO } from '@/util/const';

export default {
  name: 'Info',
  components: {
    HomePic, BreadNav,
  },
  data() {
    return {
      info: INFO,
      point: '',
      contact: {
        addr: '',
        post: '',
        workPhone: '',
        fax: '',
        mail: '',
        business: '',
        content: '',
      },
    };
  },
  created() {
    this.getCompanyContact();
  },
  methods: {
    getCompanyContact() {
      get('/getCompanyContact')
        .then((result) => {
          if (result.status === 200) {
            this.contact = result.data.contact;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    mapReady({ BMap, map }) {
      // 选择一个经纬度作为中心点
      this.point = new BMap.Point(this.info.x, this.info.y);
      map.centerAndZoom(this.point, 15);
    },
  },
};
</script>
